import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Image } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { url } from '../../../config'

// History
import history from '../../../core/history';

//image
import { SideMenuSubArrow } from '../../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import s from './QuoteSection.css';

const QuoteSection = ({ data }) => {

  const handleClick = () => {
    history.push('/become-a-host?mode=new');
  }

  const img1 = data && data.quoteSectionImage1
  const img2 = data && data.quoteSectionImage2

  return (
    <Grid className={s.container}>
      <div className={s.quotesection}>
        <div className={s.imagearea}>
          <Image src={url + '/images/home/' + img1} alt="image" responsive />
        </div>

        <div className={cx(s.contentarea, s.rightsidecontent, 'rightsidecontentRtl')}>
          <h2 className={s.quotesectionH2}>{data && data.quoteSectionTitle1}</h2>
          <h6>{data && data.quoteSectionContent1}</h6>
          <Button className={cx(s.btnlearn)} onClick={handleClick}>
            {data && data.quoteSectionButton1}
            <span className={cx(s.iconCss, 'quoteArrowRTL')}><SideMenuSubArrow className={'hostArrowRTL'} /></span>
          </Button>
        </div>
      </div>

      <div className={s.quotesection}>
        <div className={cx(s.contentarea, s.leftsidecontent, 'leftsidecontentRtl')}>
          <h2 className={s.quotesectionH2}>{data && data.quoteSectionTitle2}</h2>
          <h6>{data && data.quoteSectionContent2}</h6>
          <Button className={cx(s.btnlearn)} onClick={handleClick}>
            {data && data.quoteSectionButton2}
            <span className={cx(s.iconCss, 'quoteArrowRTL')}><SideMenuSubArrow className={'hostArrowRTL'} /></span>
          </Button>
        </div>
        <div className={s.imagearea}>
          <Image src={url + '/images/home/' + img2} alt="image" responsive />
        </div>
      </div>
    </Grid>
  );
}


QuoteSection.propTypes = {
  formatMessage: PropTypes.any,
  refer: PropTypes.string,
};

export default withStyles(s)(QuoteSection);
